import { Node } from "slate";
const getPreviousSibling = (editor, node, nodePath) => {
  const lastPathIndex = nodePath[nodePath.length - 1];
  if (lastPathIndex === 0) {
    return void 0;
  }
  const previousPath = nodePath.slice(0, -1).concat(lastPathIndex - 1);
  return [Node.get(editor, previousPath), previousPath];
};
export {
  getPreviousSibling
};
//# sourceMappingURL=getPreviousSibling.js.map
